<template>
  <v-dialog
    :value="active"
    @input="dismiss"
    lazy
    class="link--dialog"
    max-width="60vw">

      <v-card>
        <v-card-title class="headline">
          {{ $t('message.block.form.link.title') }}
        </v-card-title>
        <v-card-text>
          <v-text-field
            :label="$t('message.block.form.link.text')"
            autofocus
            v-model="selectedText"
          ></v-text-field>

          <nx-navigation-url
            @input="selectedEntity = $event"
            :excludedTypes="['empty']"
            :value="selectedEntity"
            :defaultType="defaultType"
          ></nx-navigation-url>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="dismiss">
            {{ $t('message.common.close') }}
          </v-btn>
          <v-btn
            flat
            :disabled="!isValid"
            @click="format"
            v-html="$t('message.block.form.link.accept')"
            color="accent">
          </v-btn>
        </v-card-actions>
      </v-card>

  </v-dialog>
</template>

<script>
import Quill from 'quill';

// Aunque tiene el sufijo "Button", realmente es el wizard que se levanta cuando se hace
// click sobre el botón del "link avanzado" del toolbar de quill
export default {
  name: 'nx-advanced-link-button',
  components: {
    // Se declara asíncronamente porque dentro usa un BoardSelector el cual
    // tiene como dependencia EntityWizard que llama a un form generator
    // produciendose una dependencia circular
    NxNavigationUrl: () => import('@/modules/navigation/components/NavigationUrl'),
  },
  props: {
    quill: {
      type: Object,
      validator: value => value instanceof Quill,
    },
    blot: HTMLElement,
    active: Boolean,
    text: String,
    entity: Object,
    range: Object,
    defaultType: {
      type: String,
      default: 'content',
    },
  },
  data() {
    return {
      selectedText: this.text,
      selectedEntity: this.entity || {},
    };
  },
  methods: {
    format() {
      this.quill.deleteText(this.range.index, this.range.length);
      this.quill.insertText(this.range.index, this.selectedText);

      this.quill.formatText(
        this.range.index,
        this.selectedText.length,
        'advanced-link',
        this.selectedEntity,
      );

      const format = this.quill.getFormat(this.range.index, this.range.length);
      // En caso de hubiera otros formats ie negrita, cursiva, etc. los aplicamos de nuevo para
      // no perderlos
      Object.entries(format).forEach(([blotName, value]) => {
        if (blotName !== 'advanced-link') {
          this.quill.formatText(this.range.index, this.selectedText.length, blotName, value);
        }
      });

      this.$emit('dismiss');
    },
    dismiss() {
      if (this.range) {
        this.quill.setSelection(this.selection);
      }
      this.$emit('dismiss');
    },
  },
  computed: {
    isValid() {
      return !!this.selectedEntity.url || !!this.selectedEntity.host;
    },
  },
};
</script>

<style scoped>
  .link--dialog {
    background-color: white;
  }
</style>
